import React from 'react';

export const TableV1 = ({ columns = [], rows = [] }) => {
  // Safe checks for array-ness
  const tableColumns = Array.isArray(columns) ? columns : [];
  const tableRows = Array.isArray(rows) ? rows : [];

  return (
    <div className='tw-flex tw-items-center tw-w-full tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-1 tw-border-solid tw-border-grey-200  tw-overflow-x-auto'>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          {/* Table Columns */}
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-2xl'>
              {tableColumns.length > 0 ? (
                tableColumns.map((column, index) => {
                  if (!column)
                    return (
                      <th
                        key={index}
                        className='tw-p-3 tw-bg-blue-200 tw-text-grey-800 tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-overflow-hidden tw-text-ellipsis tw-leading-snug tw-text-center'
                      >
                        <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                          &nbsp;
                        </span>
                      </th>
                    );
                  const { key, name, width } = column;
                  return (
                    <th
                      key={key ?? index}
                      title={typeof name === 'string' ? name : ''}
                      className={`tw-p-3 ${
                        width ? `tw-w-[${width}]` : ''
                      } tw-bg-blue-200 tw-text-grey-800 ${
                        index === tableColumns.length - 1
                          ? 'tw-border-r-0'
                          : 'tw-border-r'
                      } tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-overflow-hidden tw-text-ellipsis tw-leading-snug tw-text-center`}
                    >
                      <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                        {name ?? ''}
                      </span>
                    </th>
                  );
                })
              ) : (
                <th className='tw-p-3 tw-bg-blue-200 tw-text-grey-800 tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center'>
                  <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                    No Columns
                  </span>
                </th>
              )}
            </tr>
          </thead>

          {/* Table rows */}
          <tbody className='tw-bg-white'>
            {tableRows.length > 0 ? (
              tableRows.map((row, rowIndex) => {
                if (!row || typeof row !== 'object') return null;
                const entries = Object.entries(row || {});
                if (!Array.isArray(entries) || entries.length === 0) {
                  return (
                    <tr
                      key={rowIndex}
                      className='tw-text-grey-800 tw-text-center'
                    >
                      <td
                        colSpan={tableColumns.length || 1}
                        className='tw-text-center'
                      >
                        &nbsp;
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr
                    key={rowIndex}
                    className={
                      rowIndex === tableRows.length - 1
                        ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                        : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                    }
                  >
                    {entries.map(([key, rowValue], cellIndex) => {
                      const { title = null, subTitle = null } = rowValue || {};
                      return (
                        <td
                          key={key ?? cellIndex}
                          className={`tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 ${
                            cellIndex === entries.length - 1
                              ? '!tw-border-r-0'
                              : ''
                          }`}
                        >
                          <div className='tw-flex tw-flex-col tw-gap-2 tw-items-center'>
                            {title !== undefined && title !== null ? title : ''}
                            {subTitle !== undefined && subTitle !== null
                              ? subTitle
                              : ''}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={tableColumns.length || 1}
                  className='tw-text-center'
                >
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
